export default class BaseModel {
    constructor(attributes = {}) {
        this.fields = {};
        this.fieldList.forEach((field) => {
            this.fields[field] = attributes[field] || '';
        });
    }

    get fieldList() {
        return [];
    }

    get rules() {
        return {};
    }

    get attributeLabels() {
        return [];
    }
}
